import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'app/services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-dynamicgate',
  templateUrl: './dynamicgate.component.html',
  styleUrls: ['./dynamicgate.component.css']
})
export class DynamicgateComponent implements OnInit {
  spinner:boolean = false;
  conditonmet:boolean = false;
  data;
  datalength;
  randomnumber;
  constructor(private apiService : ApiService, private devicedetails : DeviceDetectorService, private router : Router) { }

  ngOnInit() {
    this.callgatesapi()
  }

  generateRandomSingleDigit(): number {
    this.randomnumber = (Math.floor(Math.random() * this.datalength));
    return this.randomnumber;
  }

  callgatesapi(){
    this.spinner = true;
    const text = "boarding in progress"
    this.apiService.getallgates().subscribe(res =>{
      this.data = [];
      this.datalength = res.data.length
      this.generateRandomSingleDigit()
      if(!this.conditonmet){
        res.data.forEach((d)=>{
          if(!this.conditonmet){
            if(d.status.toLowerCase() == text.toLowerCase()){
              this.data = d;
              this.conditonmet = true
            }
          }else {
            return ;
          }
        })
      }
      if(!this.conditonmet){
        res.data.forEach((d)=>{
          if(!this.conditonmet){
            if(d.flight && (d.status.toLowerCase() != text.toLowerCase())){
              this.data = d;
              this.conditonmet = true;
            }else if(!d.flight && (d.status.toLowerCase() != text.toLowerCase())){
              this.data.push(d);
            }
          }
        })
      }
      if(this.data.length >1){
        this.callsecondapi(this.data[this.randomnumber]);
      }else{
        this.callsecondapi(this.data)
      }
  },(error)=>{
    this.spinner= false;
  })
  }

  sessionid;
  callsecondapi(gate){
    const devicedetails = this.devicedetails.getDeviceInfo();
    const deviceres = window.innerHeight + '*' + window.innerWidth;
    const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
    const param = {
      browser_name : devicedetails.browser,
      browser_version: devicedetails.browser_version,
      device_name: devicedetails.device,
      os_name: devicedetails.os,
      os_version: devicedetails.os_version,
      user_agent: devicedetails.userAgent,
      resolution: deviceres,
      device_type: devicetype,
      gate: gate.gate_no
    }
    this.apiService.gates_api(gate.gate_no).subscribe(response => {
      let responsedata = response.data.filter(item => item !== response.data[1])
        this.apiService.setSharedData(responsedata);  
        this.apiService.getsession(param).subscribe(res =>{
            if(res.id){
              this.sessionid = res.id
              this.router.navigate(['/pax'],{ queryParams: { gateno: gate.gate_no, pax_view_session: this.sessionid } })
              this.apiService.setsessionId('sessionId', this.sessionid,2);
            }
            this.spinner = false;
          },(error)=>{
            this.spinner = false;
          })
    },(error)=>{
      this.spinner = false;
    })   
  }

}
